import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const PreviewIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 32),
    ...svgProps,
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "M16.7 25.31c-.28-.16-.57-.32-.9-.45a4.09 4.09 0 00-4.8 1.1c-.47.57-.38 1.05.3 1.37 2.9 1.34 5.82 2.69 8.73 4 2.4 1.09 4.7.86 6.82-.7a6.42 6.42 0 002.62-6.21c-.06-.52-.19-1-.35-1.48-.35-1.02-.74-2.01-1.12-3.04a2.15 2.15 0 00-1.76-1.47l-4.51-.77-.48-.1c-1.03-.22-1.86.2-2.37 1.13 0 .06 0 .1-.06.19-.07-.13-.1-.2-.13-.29l-1.44-3.84c-.45-1.15-1.6-1.73-2.69-1.31s-1.6 1.6-1.15 2.75c1.09 2.91 2.14 5.83 3.23 8.74l.1.25zM10.2 7.49c.2.51.8.8 1.32.6l1.73-.67c.51-.19.8-.8.6-1.3L11.82.66c-.2-.51-.8-.8-1.31-.6L8.77.73c-.51.19-.8.8-.61 1.3zM17.22 6.18c-.23.5 0 1.12.5 1.34l1.6.74c.52.22 1.13 0 1.35-.52l2.34-5.18c.22-.51 0-1.12-.51-1.34L20.9.48c-.52-.22-1.12 0-1.35.51zM29.76 11.78c.51-.2.8-.8.6-1.32l-.66-1.72c-.2-.52-.8-.8-1.32-.61l-5.44 2.05c-.5.19-.8.8-.6 1.3l.67 1.74c.19.5.8.8 1.31.6zM7.49 20.2c.51-.2.8-.8.6-1.32l-.67-1.73c-.19-.51-.8-.8-1.3-.6L.66 18.58c-.51.2-.8.8-.6 1.31l.67 1.76c.19.52.8.8 1.3.58zM2.46 7.4c-.5-.23-1.12 0-1.34.5L.45 9.4c-.23.52 0 1.13.51 1.35l5.31 2.4c.51.23 1.12 0 1.35-.51l.67-1.47c.22-.51 0-1.12-.51-1.35z"
    })
  });
};

export { PreviewIcon };
//# sourceMappingURL=preview.js.map
